module.exports = __webpack_public_path__ + "img/Balance-inspect-small.54ea58b2.jpg";